import React from 'react';

export type SystemConfigTabId =
  | 'personnel'
  | 'vehicules'
  | 'competences'
  | 'fonctions-armement'
  | 'formations'
  | 'batiments'
  | 'partenaires'
  | 'categories-mission'
  | 'categories-spe';

interface SystemConfigTabsNavProps {
  activeTab: SystemConfigTabId;
  setActiveTab: (id: SystemConfigTabId) => void;
  t?: (key: string) => string;
}

const TABS: { id: SystemConfigTabId; label: string }[] = [
  { id: 'personnel', label: 'Personnel' },
  { id: 'vehicules', label: 'Véhicules' },
  { id: 'competences', label: 'Compétences' },
  { id: 'fonctions-armement', label: 'Fonctions armement' },
  { id: 'formations', label: 'Formations' },
  { id: 'batiments', label: 'Bâtiments' },
  { id: 'partenaires', label: 'Partenaires' },
  { id: 'categories-mission', label: 'Catégories mission' },
  { id: 'categories-spe', label: 'Catégories spé' },
];

/** Barre d'onglets extraite de SystemConfiguration.tsx. */
const SystemConfigTabsNav: React.FC<SystemConfigTabsNavProps> = ({
  activeTab,
  setActiveTab,
  t,
}) => (
  <div className="flex flex-wrap border-b border-[#1e2d4d] mb-6">
    {TABS.map((tab) => (
      <button
        key={tab.id}
        onClick={() => setActiveTab(tab.id)}
        className={`px-5 py-3 text-sm font-medium transition-colors relative ${
          activeTab === tab.id
            ? 'text-[#7b93f5] border-b-2 border-[#3d4fdb]'
            : 'text-slate-400 hover:text-white'
        }`}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export default SystemConfigTabsNav;
